import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useListFilter } from '@/components/layout/record-nav-context'
import { orpc } from '@/lib/orpcClient'
import { DocumentEditor } from '@/routes/finance/-DocumentEditor'

export const Route = createFileRoute('/finance/credit-notes/$id/')({
  component: CreditNoteDetailPage,
})

function CreditNoteDetailPage() {
  const navigate = useNavigate()
  const { id } = Route.useParams()
  const { filter } = useListFilter('creditNote')

  const neighborsQ = useQuery(
    orpc.finance.documents.creditNoteNeighbors.queryOptions({
      input: {
        id,
        search: filter.search || undefined,
        sort: filter.sort,
        // Ook de lijstfilters (status, relatie), zodat positie/totaal en
        // vorige/volgende over precies dezelfde rijen lopen als de lijst toonde.
        filters: filter.filters,
      },
    }),
  )

  return (
    <div className="p-6">
      <DocumentEditor
        kind="ar_credit_note"
        documentId={id}
        nav={{
          entityKey: 'creditNote',
          neighbors: neighborsQ.data,
          listRoute: '/finance/credit-notes',
          toDetail: (id) =>
            navigate({
              to: '/finance/credit-notes/$id',
              params: { id },
              search: (prev) => prev,
            }),
        }}
      />
    </div>
  )
}
